import React, { Component } from 'react'
import PropTypes from 'prop-types';

class WordSearch extends Component {

    state = {
        text : '',
        term : '',
        url: ''
    }

    static propTypes = {
        searchUrl: PropTypes.func.isRequired,
        setAlert: PropTypes.func.isRequired,
        searchTerm: PropTypes.func.isRequired
    }


    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    onSubmit=(e) => {
        e.preventDefault();
        //alert for submit blank form
        if(this.state.text === '' || this.state.term === ''){
            this.props.setAlert('Please enter a valid URL and Search Term', 'light');
        } else {
            this.props.searchUrl(this.state.text);
            this.props.searchTerm(this.state.term);            
            //this.setState({ text: '' });
        }

    }

    render() {
        return (
            <div>
                <form onSubmit={this.onSubmit} className="form">
                    <input type="text" name="text" placeholder="Search URL..." value={this.state.text} onChange={this.onChange}/>
                    Search Term
                    <input type="text" name="term" placeholder="Search Term..." value={this.state.term} onChange={this.onChange}/>
                    <input type="submit" value="Search" className="btn btn-dark btn-block" />
                </form>
                {this.props.showClear && <button className="btn btn-light btn-block" onClick={this.props.clearUsers}>Clear</button>}
            </div>
        )
    }
}

export default WordSearch



// WEBPACK FOOTER //
// ./src/components/layout/WordSearch.js